import { Component } from '@angular/core';

/*import {DefaultModalComponent} from "./default-modal/default-modal.component";
import {SendInviteModalComponent} from "./send-invite-modal/send-invite-modal.component";
import {ResultModalComponent} from "./result-modal/result-modal.component";*/

@Component({
  selector: 'Modal',
  templateUrl: 'modal.component.html',
  styleUrls: ['modal.component.css']
})
export class ModalComponent {
  constructor() {}
}
